import React, { useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./ProfileBasicInfo.css";
import profileLogo from "../../../assets/profile/Eb-logo-for-profile.svg";
import { updateProfile } from "../../../services/Trainer/trainer";
import { toast } from "react-toastify";
import rankOne from "../../../assets/leaderboard/rank-one.svg";

const ProfileBasicInfo = ({ userData, onUpdateUser }) => {
  const profileData = userData?.data;

  const [showEditModal, setShowEditModal] = useState(false);
  // const [imagePreview, setImagePreview] = useState(userData?.data?.profileImageUrl || '');
  const [imagePreview, setImagePreview] = useState(
    profileData?.profileImageUrl
      ? `${process.env.REACT_APP_BUCKET_URL}${profileData.profileImageUrl}`
      : ""
  );
  const [isEditingImage, setIsEditingImage] = useState(false);
  const [newImageFile, setNewImageFile] = useState(null);
  const fileInputRef = useRef(null);

  // Use passed userData or fallback to default instructor data

  // Validation schema using Yup
  const validationSchema = (imagePreview) =>
    Yup.object({
      fullName: Yup.string()
        .min(2, "Full name must be at least 2 characters")
        .max(50, "Full name must be less than 50 characters")
        .required("Full name is required"),

      clinicBranch: Yup.string().required("Please select a clinic branch"),

      profileImageUrl: !imagePreview
        ? Yup.string().required("Profile image is required")
        : Yup.string().notRequired(),
    });

  // Handle form submission
  // const handleSubmit = (values, { setSubmitting }) => {
  //   // Simulate API call
  //   setTimeout(() => {
  //     console.log('Updated user data:', values);

  //     // Call parent component's update function if provided
  //     if (onUpdateUser) {
  //       onUpdateUser(values);
  //     }

  //     setSubmitting(false);
  //     setShowEditModal(false);

  //     // You can add success notification here
  //     alert('Profile updated successfully!');
  //   }, 1000);
  // };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      console.log("vlaues>>>", values, newImageFile);
      const formData = new FormData();
      formData.append("fullName", values.fullName);
      formData.append("clinicBranch", values.clinicBranch);

      if (newImageFile) {
        formData.append("profileImageUrl", newImageFile); // send binary file
      } else {
        formData.append("profileImageUrl", values.profileImageUrl); // just send URL
      }
      const result = await updateProfile(formData);

      if (result?.success) {
        // setLoading(false);
        setSubmitting(false);

        toast.success(result?.message);
        setShowEditModal(false);
        onUpdateUser();

        // navigate(-1)
      } else {
        // setLoading(false);
        setSubmitting(false);

        toast.error(result?.message);
        setShowEditModal(false);
      }
    } catch (error) {
      // Replace this with your API call
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };
  const getInitials = (name) => {
    return name ? name.charAt(0).toUpperCase() : "U";
  };

  return (
    <>
      <div className="profile-cards-container">
        <div className="row g-3">
          {/* Left Card - Profile Information */}
          <div className="col-lg-8">
            <div className="profile-info-card">
              <div className="row g-0 align-items-center">
                {/* Profile Image */}
                <div className="col-auto">
                  <div className="profile-image-container">
                    {/* <img 
                      src={profileData?.image || "/placeholder.svg"} 
                      alt={profileData?.fullName} 
                      className="profile-image"
                    /> */}
                    {profileData?.profileImageUrl !== "" ? (
                      <img
                        // src={profileData?.profileImageUrl}
                        src={`${process.env.REACT_APP_BUCKET_URL}${profileData?.profileImageUrl}`}
                        alt={profileData?.fullName}
                        className="user-avatar rounded-circle"
                        style={{
                          width: "48px",
                          height: "48px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div
                        // className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-muted fw-bold user-avatar rounded-circle"
                        className="user-avatar rounded-circle"
                        style={{
                          width: "48px",
                          height: "48px",
                          objectFit: "cover",
                        }}
                      >
                        {/* {profileData?.fullName || ''} */}
                        {getInitials(profileData?.fullName || "")}
                      </div>
                    )}
                  </div>
                </div>

                {/* Profile Information */}
                <div className="col">
                  <div className="profile-info">
                    <div className="d-flex align-items-center mb-2">
                      <h4 className="profile-name mb-0 me-3">
                        {profileData?.fullName}
                      </h4>
                      {profileData?.isActive && (
                        <span className="badge active-badge">Active</span>
                      )}
                      {/* Edit Button */}
                      <button
                        className="btn btn-outline-primary btn-sm ms-auto edit-btn"
                        onClick={() => setShowEditModal(true)}
                      >
                        <i className="fas fa-edit me-1"></i>
                        Edit
                      </button>
                    </div>

                    <div className="profile-details">
                      {profileData?.role && (
                        <div className="detail-row">
                          <span className="detail-label">Position:</span>
                          <span className="detail-value">
                            {profileData?.role}
                          </span>
                        </div>
                      )}

                      {profileData?.username && (
                        <div className="detail-row">
                          <span className="detail-label">Email:</span>
                          <span className="detail-value">
                            {profileData?.username}
                          </span>
                        </div>
                      )}

                      {profileData?.phone && (
                        <div className="detail-row">
                          <span className="detail-label">Phone:</span>
                          <span className="detail-value">
                            {profileData?.phone}
                          </span>
                        </div>
                      )}

                      {/* <div className="detail-row">
                        <span className="detail-label">Clinic Branch:</span>
                        <span className="detail-value">{profileData?.clinicBranch}</span>
                      </div> */}
                    </div>
                  </div>
                </div>

                {/* Clinic Image at the end */}
                <div className="col-auto">
                  <div className="clinic-image-container">
                    <img
                      src={profileLogo}
                      alt="Clinic Interior"
                      className="clinic-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Card - Gamifications */}
          <div className="col-lg-4">
            <div className="gamification-card">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h6 className="gamification-title mb-0">Gamifications</h6>
                {/* <button className="btn btn-link p-0 more-options">
                  <span>⋯</span>
                </button> */}
              </div>

              <div className="rank-container text-center mb-3">
                {/* <div className="rank-icon">
                  <div className="medal-icon">
                    <span className="star">⭐</span>
                  </div>
                </div>
                <h6 className="rank-text">Rank</h6> */}
                <div className="" style={{ position: "relative" }}>
                  <img
                    style={{ width: "45%" }}
                    src={rankOne}
                    alt={`Rank rankOne`}
                    className="rank-frame-img"
                  />
                  <div className="profile-pic-img">
                    {userData?.topper.length > 0 ? (
                      <img
                        src={
                          userData?.topper[0]?.profileImageUrl
                            ? `${process.env.REACT_APP_BUCKET_URL}${userData?.topper[0]?.profileImageUrl}`
                            : "https://thumbs.dreamstime.com/b/profile-photo-placeholder-icon-design-blue-icon-avatar-placeholder-user-interface-design-profile-photo-placeholder-icon-design-251107517.jpg"
                        }
                        alt={userData?.topper[0]?.fullName}
                      />
                    ) : (
                      <span>TBA</span>
                    )}
                  </div>

                  <div
                    className="medal-rank"
                    style={{
                      backgroundColor: "gold",
                    }}
                  >
                    1
                  </div>
                </div>
                {userData?.topper[0]?.fullName && (
                  <p>{userData?.topper[0]?.fullName}</p>
                )}
              </div>

              <div className="stats-container">
                {/* <div className="stat-item">
                  <span className="stat-label">Courses</span>
                  <span className="stat-value">{profileData?.courses}</span>
                </div> */}

                <div className="stat-item">
                  <span className="stat-label">Points</span>
                  <span className="stat-value">{userData?.score}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      {showEditModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Profile Information</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                ></button>
              </div>

              <Formik
                initialValues={{
                  fullName: profileData?.fullName,
                  clinicBranch: profileData?.clinicBranch || "",
                  profileImageUrl: profileData?.profileImageUrl,
                }}
                validationSchema={validationSchema(imagePreview)}
                onSubmit={handleSubmit}
              >
                {({
                  isSubmitting,
                  errors,
                  touched,
                  setFieldTouched,
                  setFieldValue,
                }) => (
                  <Form>
                    <div className="modal-body">
                      <div className="row">
                        {/* Full Name */}
                        <div className="col-md-6 mb-3">
                          <label htmlFor="fullName" className="form-label">
                            Full Name <span className="text-danger">*</span>
                          </label>
                          <Field
                            type="text"
                            className={`form-control ${
                              errors.fullName && touched.fullName
                                ? "is-invalid"
                                : ""
                            }`}
                            id="fullName"
                            name="fullName"
                            placeholder="Enter full name"
                          />
                          <ErrorMessage
                            name="fullName"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>

                        <div className="col-md-6 mb-3">
                          <label htmlFor="clinicBranch" className="form-label">
                            Clinic Branch
                          </label>
                          <Field
                            as="select"
                            className="form-select"
                            id="clinicBranch"
                            name="clinicBranch"
                          >
                            <option value="" disabled>
                              Select a branch
                            </option>
                            <option value="alphington">Alphington</option>
                            <option value="ringwood">Ringwood</option>
                            <option value="ringwood/alphington">
                              Ringwood/Alphington
                            </option>
                          </Field>
                          <ErrorMessage
                            name="clinicBranch"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        {/* Profile Image URL */}
                        {/* <div className="col-md-6 mb-3">
                          <label htmlFor="profileImageUrl" className="form-label">
                            Profile Image URL <span className="text-danger">*</span>
                          </label>
                          <Field
                            type="url"
                            className={`form-control ${errors.image && touched.image ? 'is-invalid' : ''}`}
                            id="profileImageUrl"
                            name="profileImageUrl"
                            placeholder="Enter profile image URL"
                          />
                          <ErrorMessage name="profileImageUrl" component="div" className="invalid-feedback" />
                        </div> */}
                        {/* Profile Image Section */}

                        <div className="col-md-6 mb-3">
                          <label className="form-label">
                            Profile Image <span className="text-danger">*</span>
                          </label>

                          <div className="position-relative">
                            {imagePreview ? (
                              <>
                                <img
                                  // src={`${process.env.REACT_APP_BUCKET_URL}${imagePreview}`}
                                  src={imagePreview}
                                  alt="Profile"
                                  className="img-thumbnail"
                                  style={{
                                    width: 150,
                                    height: 150,
                                    objectFit: "cover",
                                  }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary position-absolute top-0 end-0"
                                  onClick={() => fileInputRef.current?.click()}
                                >
                                  <i className="bi bi-pencil"></i>
                                </button>
                              </>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => fileInputRef.current?.click()}
                              >
                                Upload Image
                              </button>
                            )}
                          </div>

                          {/* Hidden File Input */}
                          <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            className="d-none"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                setNewImageFile(file);
                                setImagePreview(URL.createObjectURL(file));
                                setFieldValue("profileImageUrl", "uploaded");
                                setFieldTouched("profileImageUrl", true, false);
                              } else {
                                setNewImageFile(null);
                                setImagePreview("");
                                setFieldValue("profileImageUrl", "");
                                setFieldTouched("profileImageUrl", true, false);
                              }
                            }}
                          />
                        </div>

                        {touched.profileImageUrl && errors.profileImageUrl && (
                          <div className="text-danger ">
                            {errors.profileImageUrl}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowEditModal(false)}
                        disabled={isSubmitting}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Updating...
                          </>
                        ) : (
                          "Update Profile"
                        )}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileBasicInfo;
